import { render } from "./ProjectPublicationHistoryListChanges.vue?vue&type=template&id=33269998&scoped=true"
import script from "./ProjectPublicationHistoryListChanges.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListChanges.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListChanges.vue?vue&type=style&index=0&id=33269998&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33269998"]])

export default __exports__